<template>
  <v-container fluid class="px-4 py-6">
    <app-city-header :payload="payload"> </app-city-header>

    <!-- Cabeçalho melhorado -->
    <v-card class="mb-6" elevation="2">
      <v-card-text class="pa-4">
        <v-row align="center" no-gutters>
          <v-col cols="12" md="4">
            <v-text-field
              label="Nome do acompanhamento"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
              disabled
              variant="outlined"
              density="compact"
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3" class="px-3">
            <div class="d-flex align-center">
              <v-icon color="grey" class="mr-2">mdi-calendar</v-icon>
              <div>
                <div class="text-caption text-grey">Criado em</div>
                <div class="font-weight-medium">
                  {{ payload.criacao | moment("DD/MM/YYYY") }}
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="5" class="text-md-right">
            <div
              class="d-flex flex-column flex-md-row justify-end align-center ga-2"
            >
              <v-btn
                v-if="
                  !payload.finalizado &&
                  !payload.diagnostico &&
                  (isAdmin || payload.usuarioId === user.usuarioId) &&
                  (isFullAdmin ||
                    (config.finalizarAcompanhamento &&
                      groupsConfig.finalizarAcompanhamento))
                "
                color="success"
                variant="tonal"
                prepend-icon="mdi-check-circle"
                @click="finalizarAcompanhamento()"
              >
                Finalizar
              </v-btn>
              <v-btn
                color="primary"
                variant="outlined"
                prepend-icon="mdi-download"
                @click="createPDF"
              >
                Download PDF
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Seção de Filtros melhorada -->
    <v-card class="mb-6 filter-card" elevation="2">
      <v-card-title class="filter-header pa-4">
        <v-row align="center" no-gutters>
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <v-icon class="mr-3" color="primary" size="24">mdi-filter</v-icon>
              <div>
                <div class="text-h6 mb-0">Filtros</div>
                <div class="text-caption text-grey">
                  Encontre rapidamente as perguntas desejadas
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="text-md-right">
            <v-btn
              v-if="search.length > 0 || textSearch"
              variant="outlined"
              color="grey"
              size="small"
              @click="clearFilters"
              prepend-icon="mdi-filter-remove"
            >
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pt-0 pb-4">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="search"
              :items="availableQuestions"
              item-title="texto"
              item-value="numero"
              label="Filtrar por Perguntas"
              multiple
              clearable
              variant="outlined"
              density="comfortable"
              prepend-inner-icon="mdi-magnify"
              hide-details
              closable-chips
              placeholder="Digite para buscar perguntas..."
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  color="primary"
                  variant="tonal"
                  size="small"
                  closable
                  class="mr-1"
                >
                  {{ item.numero }} - {{ item.texto.substring(0, 30)
                  }}{{ item.texto.length > 30 ? "..." : "" }}
                </v-chip>
                <span
                  v-if="index === 2"
                  class="text-grey text-caption align-self-center"
                >
                  (+{{ search.length - 2 }} outros)
                </span>
              </template>
              <template v-slot:item="{ props, item }">
                <v-chip
                  color="primary"
                  variant="tonal"
                  size="x-small"
                  class="mr-2"
                >
                  {{ item.numero }}
                </v-chip>
                {{ item.texto }}
              </template>
              <template v-slot:no-data>
                <div class="text-center pa-4">
                  <v-icon color="grey" size="32">mdi-help-circle</v-icon>
                  <div class="text-caption text-grey mt-2">
                    Nenhuma pergunta encontrada
                  </div>
                </div>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- Informações do filtro -->
        <div v-if="search.length > 0 || textSearch" class="filter-info mt-3">
          <v-row align="center">
            <v-col>
              <div class="d-flex align-center flex-wrap ga-2">
                <v-chip
                  color="info"
                  variant="tonal"
                  size="small"
                  prepend-icon="mdi-filter-check"
                >
                  {{ filteredCount }} de {{ totalCount }} perguntas
                </v-chip>
                <span class="text-caption text-grey">
                  {{
                    search.length > 0
                      ? `${search.length} pergunta(s) selecionada(s)`
                      : ""
                  }}
                  {{ textSearch ? `Buscando por: "${textSearch}"` : "" }}
                </span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <!-- Seções de perguntas melhoradas -->
    <div
      v-for="(filtered, index) in filteredItems"
      :key="index"
      ref="pmdTable"
      class="mb-6"
    >
      <v-card elevation="2">
        <v-card-title
          class="category-header text-white pa-4"
          style="color: #fff"
        >
          <v-icon class="mr-3" color="#fff">mdi-format-list-checks</v-icon>
          {{ filtered.name }}
          <v-spacer></v-spacer>
          <v-chip color="rgba(255,255,255,0.2)" text-color="white" small>
            {{ filtered.children.length }} questões
          </v-chip>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="filtered.children"
          hide-default-footer
          disable-pagination
          class="elevation-0 compact-table"
          density="compact"
          :item-props="() => ({ class: 'compact-row' })"
        >
          <template v-slot:item.pergunta="{ item }">
            <div class="question-container pa-2">
              <!-- Header compacto da pergunta -->
              <div class="d-flex align-center mb-1">
                <v-chip
                  color="primary"
                  variant="tonal"
                  size="small"
                  class="mr-3 flex-shrink-0"
                  style="white-space: nowrap"
                >
                  {{ item.pergunta.numero }}
                </v-chip>
                <div class="question-text flex-grow-1">
                  {{ item.pergunta.texto }}
                </div>
              </div>

              <!-- Evidência válida com layout melhorado -->
              <v-card
                v-if="item.pergunta.evidencia"
                variant="tonal"
                color="info"
                class="mt-3 mb-2 evidence-card"
                elevation="0"
              >
                <v-card-text class="pa-3">
                  <div class="d-flex align-start">
                    <v-icon
                      color="info"
                      size="20"
                      class="mr-3 mt-1 flex-shrink-0"
                    >
                      mdi-information-outline
                    </v-icon>
                    <div class="flex-grow-1">
                      <div
                        class="text-info font-weight-medium text-caption mb-1"
                      >
                        EVIDÊNCIA VÁLIDA
                      </div>
                      <div class="text-body-2 line-height-comfortable">
                        {{ item.pergunta.evidencia }}
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Alertas e informações compactas -->
              <div class="question-info">
                <v-alert
                  v-if="isPergunta1005Bloqueada(item)"
                  type="warning"
                  variant="tonal"
                  density="compact"
                  class="mb-2"
                >
                  <template v-slot:prepend>
                    <v-icon size="small">mdi-lock</v-icon>
                  </template>
                  Questão bloqueada - depende da questão 1003
                </v-alert>
              </div>

              <!-- Inputs em linha -->
              <div class="question-inputs">
                <!-- Comentário compacto -->
                <v-textarea
                  v-if="
                    item.pergunta.possuiComentario &&
                    !payload.finalizado &&
                    !payload.diagnostico &&
                    payload.usuarioId === user.usuarioId
                  "
                  label="Comentário"
                  v-model="item.comentario"
                  :maxlength="1000"
                  variant="outlined"
                  density="compact"
                  hide-details
                  no-resize
                  rows="2"
                  filled
                  class="comment-input mt-2"
                  @input="addComentarioPergunta(item)"
                >
                  <template v-slot:append-inner>
                    <span class="text-caption text-grey"
                      >{{
                        item.comentario ? item.comentario.length : 0
                      }}/1000</span
                    >
                  </template>
                </v-textarea>

                <!-- Comentário somente leitura -->
                <div
                  v-if="
                    item.comentario &&
                    (payload.finalizado ||
                      payload.diagnostico ||
                      payload.usuarioId !== user.usuarioId)
                  "
                  class="readonly-comment mt-2 pa-2 bg-grey-lighten-4 rounded"
                >
                  <v-icon size="small" class="mr-1">mdi-comment-text</v-icon>
                  <span class="text-caption font-weight-bold">Comentário:</span>
                  <div class="text-body-2 mt-1">{{ item.comentario }}</div>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:item.acoes="{ item }">
            <!-- Perguntas Boolean (Sim/Não) -->

            <div
              v-if="
                item.pergunta.tipo_resposta_id ==
                perguntasTipoRespostaEnum.boolean
              "
              class="d-flex justify-center align-center ga-4 py-2 question-container"
            >
              <!-- Botão SIM -->

              <v-btn
                :class="[
                  'thumb-btn',
                  item.resposta === true || item.resposta === 'SIM'
                    ? 'thumb-btn--selected thumb-btn--success'
                    : 'thumb-btn--unselected',
                  'mr-4',
                ]"
                size="large"
                icon
                :disabled="isReadOnly(item)"
                @click="responderPergunta(item, true)"
              >
                <v-icon size="large">mdi-thumb-up</v-icon>
                <v-tooltip activator="parent" location="top"
                  >Clique para SIM</v-tooltip
                >
              </v-btn>

              <!-- Indicador de resposta -->
              <div class="response-indicator mr-4">
                <v-chip
                  v-if="item.resposta === true || item.resposta === 'SIM'"
                  color="success"
                  size="small"
                  variant="flat"
                >
                  SIM
                </v-chip>
                <v-chip
                  v-else-if="item.resposta === false || item.resposta === 'NÃO'"
                  color="error"
                  size="small"
                  variant="flat"
                >
                  NÃO
                </v-chip>
                <span v-else class="text-caption text-grey">--</span>
              </div>

              <div v-if="getEvidenciaStatus(item)" class="mr-4">
                <v-chip
                  :color="getEvidenciaStatus(item).color"
                  size="small"
                  variant="tonal"
                >
                  {{ getEvidenciaStatus(item).text }}
                </v-chip>
              </div>

              <!-- Botão NÃO -->
              <v-btn
                :class="[
                  'thumb-btn',
                  item.resposta === false || item.resposta === 'NÃO'
                    ? 'thumb-btn--selected thumb-btn--error'
                    : 'thumb-btn--unselected',
                ]"
                size="large"
                icon
                :disabled="isReadOnly(item)"
                @click="responderPergunta(item, false)"
              >
                <v-icon size="large">mdi-thumb-down</v-icon>
                <v-tooltip activator="parent" location="top"
                  >Clique para NÃO</v-tooltip
                >
              </v-btn>
            </div>

            <div
              v-else-if="
                item.pergunta.tipo_resposta_id ==
                perguntasTipoRespostaEnum.numero
              "
              class="d-flex justify-center align-center py-2"
            >
              <!-- Input numérico com label melhorado -->
              <v-text-field
                v-model="item.resposta2"
                type="number"
                variant="outlined"
                density="comfortable"
                hide-details
                style="min-width: 120px"
                :disabled="isReadOnly(item)"
                @blur="addResposta2Pergunta(item)"
                label="Resposta"
                class="numeric-field-centered w-100"
              ></v-text-field>
            </div>
          </template>
          <template slot="no-data">
            <div class="text-center py-8">
              <v-icon size="48" color="grey">mdi-clipboard-text-off</v-icon>
              <div class="text-h6 text-grey mt-2">
                Nenhuma pergunta encontrada
              </div>
              <div class="text-caption text-grey">
                Tente ajustar os filtros para ver mais resultados
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { attendanceAPI } from "@/modules/attendance";
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { cityAPI } from "../../city/API/CityAPI";
import { cityQuestionAPI } from "../../city/API/CityQuestionAPI";
import {
  statusRelacionamentoEnum,
  statusContratoEnum,
  statusRelacionamentoSeloEnum,
  perguntasTipoRespostaEnum,
} from "@/types";
import { convertImgToBase64 } from "@/helpers/convertImgToBase64";
import {
  aplicarNaoNasPerguntasCondicionais,
  limparAprovacaoAutomaticaRespostaNegativa,
} from "../utils/regrasCondicionaisAcompanhamento.mjs";

export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      headers: [
        { text: "Questões", value: "pergunta", width: "60%" },
        { text: "Ações", value: "acoes", width: "40%", align: "center" },
      ],
      regrasCondicionais: [
        { perguntaCondicional: "1004.1", perguntaPrincipal: "1004" },
        //{ perguntaCondicional: "1005", perguntaPrincipal: "1003" },
        { perguntaCondicional: "1007.1", perguntaPrincipal: "1007" },
        { perguntaCondicional: "1008.1", perguntaPrincipal: "1008" },
        { perguntaCondicional: "1008.2", perguntaPrincipal: "1008.1" },
        { perguntaCondicional: "1012.1", perguntaPrincipal: "1012" },
        { perguntaCondicional: "1013.2", perguntaPrincipal: "1013.1" },
        { perguntaCondicional: "1020.1", perguntaPrincipal: "1020" },
      ],
      payload: {
        criacao: "",
        municipioId: 1,
        perguntas: [],
      },
      estado: this.$store.state.uf,
      municipioId: this.$route.params.id,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      search: [],
      textSearch: "",
      municipioTemas: [],
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusContratoEnum: statusContratoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      perguntasTipoRespostaEnum: perguntasTipoRespostaEnum,
      pergunta1005Bloqueada: false,
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    getQuestionByNumber(numero) {
      return this.availableQuestions.find((q) => q.numero === numero);
    },
    clearFilters() {
      this.search = [];
      this.textSearch = "";
    },
    handleTextSearch() {
      // Método para lidar com a busca por texto em tempo real
      // A lógica de filtro será aplicada no computed filteredItems
    },
    isPergunta1005Bloqueada(item) {
      return (
        item &&
        item.pergunta &&
        item.pergunta.numero == "1005" &&
        this.pergunta1005Bloqueada
      );
    },
    atualizarBloqueioPergunta1005() {
      this.payload.perguntas.forEach((pergunta) => {
        if (pergunta.pergunta.numero === "1005") {
          this.$set(pergunta, "respostaBloqueada", this.pergunta1005Bloqueada);
          if (this.pergunta1005Bloqueada) {
            pergunta.resposta = false;
            pergunta.respondida = true;
          }
        }
      });
    },
    loadCity(municipioId, attendance) {
      cityAPI.get(municipioId).then(({ data }) => {
        this.municipioTemas = data.temas;
        this.payload = attendance;

        if (this.getMunicipioNaoVigenteRespondeSoPerguntasNacionais(data)) {
          this.payload.perguntas = attendance.perguntas.filter(
            (perguntas) => perguntas.pergunta.nacional
          );
        }
        this.payload.perguntas = this.payload.perguntas.filter((item) =>
          this.municipioTemas.some(
            (tema) => item.pergunta.temaId === tema.temaId
          )
        );
        if (!this.user.grupo.verTodosEixos) {
          this.payload.perguntas = this.payload.perguntas.filter((item) =>
            this.user.permissoes.some(
              (per) =>
                per.eixoId === item.pergunta.tema.eixoId &&
                per.municipioId === this.payload.municipioId
            )
          );
        }
        this.getPergunta();
      });
    },
    getAcompanhamento() {
      this.setLoading(true);

      attendanceAPI
        .get(this.$route.params.acompanhamento)
        .then((resp) => {
          this.loadCity(resp.data.municipioId, resp.data);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter acompanhamentos");
        });
    },
    getMunicipioNaoVigenteRespondeSoPerguntasNacionais(municipio) {
      if (this.isFullAdmin) return false;
      if (
        this.config.municipiosNaoVigentesRespondemPerguntasNacionais &&
        this.groupsConfig.municipiosNaoVigentesRespondemPerguntasNacionais &&
        !this.getMunicipioVigente(municipio)
      ) {
        return true;
      }

      return false;
    },
    getMunicipioVigente(municipio) {
      let isVigente = true;

      return isVigente;
    },
    responderPergunta(item, resposta) {
      if (this.isPergunta1005Bloqueada(item)) {
        return item;
      }
      if (this.isReadOnly(item)) {
        return item;
      }

      this.payload.perguntas.forEach((val) => {
        if (val.acompanhamentoPerguntaId == item.acompanhamentoPerguntaId) {
          val.resposta = resposta;
          val.respondida = true;
          limparAprovacaoAutomaticaRespostaNegativa(val);
        }
      });

      item.resposta = resposta;
      item.respondida = true;
      limparAprovacaoAutomaticaRespostaNegativa(item);

      // Regra: se pergunta 1003 for respondida como "não", a pergunta 1005 também deve ser "não"
      if (item.pergunta.numero === "1003") {
        this.pergunta1005Bloqueada = !resposta;
        const pergunta1005 = this.payload.perguntas.find(
          (p) => p.pergunta.numero === "1005"
        );
        if (pergunta1005) {
          if (this.pergunta1005Bloqueada) {
            pergunta1005.resposta = false;
            pergunta1005.respondida = true;
          }
          this.$set(
            pergunta1005,
            "respostaBloqueada",
            this.pergunta1005Bloqueada
          );
        }
        this.$forceUpdate();
      }

      if (!resposta) {
        aplicarNaoNasPerguntasCondicionais(
          this.payload.perguntas,
          this.regrasCondicionais,
          item.pergunta.numero
        );
      }
      if (item.pergunta.numero === "1003") {
        this.atualizarBloqueioPergunta1005();
      }
      this.$forceUpdate();

      return item;
    },
    addResposta2Pergunta(item) {
      if (this.isRespostaNumericaAprovada(item)) {
        return;
      }

      this.payload.perguntas.forEach((val) => {
        if (val.acompanhamentoPerguntaId == item.acompanhamentoPerguntaId) {
          val.resposta2 = item.resposta2;
          val.resposta = !!item.resposta2;
          val.respondida = !!item.resposta2;
        }
      });
    },
    addComentarioPergunta(item) {
      this.payload.perguntas.forEach((val) => {
        if (val.acompanhamentoPerguntaId == item.acompanhamentoPerguntaId) {
          val.comentario = item.comentario;
        }
      });
    },
    finalizarAcompanhamento() {
      this.setLoading(true);
      attendanceAPI
        .finalizar(this.payload)
        .then((resp) => {
          this.$router.push("/cidade/" + this.payload.municipioId);
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          const mensagem = resp.response && resp.response.status === 400 &&
            typeof resp.response.data === "string" ? resp.response.data :
            "Erro ao finalizar acompanhamento";
          this.$notification.error(mensagem);
        });
    },
    isReadOnly(item) {
      return (
        this.payload.finalizado ||
        this.payload.diagnostico ||
        (item.resposta && !item.respondida && !item.pergunta.recorrente &&
          !item.aprovacaoAutomaticaSemEvidencia) ||
        this.isRespostaSimBloqueadaPorAnalise(item) ||
        this.isRespostaNumericaAprovada(item) ||
        this.isPergunta1005Bloqueada(item)
      );
    },
    isRespostaSimBloqueadaPorAnalise(item) {
      return (
        this.isRespostaSim(item) &&
        !item.aprovacaoAutomaticaSemEvidencia &&
        (item.aprovada || (item.evidenciada && !item.rejeitada))
      );
    },
    isRespostaNumericaAprovada(item) {
      return (
        item &&
        item.pergunta &&
        item.pergunta.tipo_resposta_id == this.perguntasTipoRespostaEnum.numero &&
        !item.aprovacaoAutomaticaSemEvidencia &&
        item.aprovada
      );
    },
    isRespostaSim(item) {
      return item.resposta === true || item.resposta === "SIM";
    },
    getEvidenciaStatus(item) {
      if (!this.isRespostaSim(item)) {
        return null;
      }
      if (!item.evidenciada) {
        return null;
      }
      if (item.aprovada) {
        return { text: "Evidência aprovada", color: "success" };
      }
      if (item.rejeitada) {
        return {
          text: "Aguardando substituição de evidência enviada",
          color: "warning",
        };
      }
      return { text: "Aguardando análise da evidência", color: "info" };
    },
    async createPDF() {
      var source = this.payload.perguntas;
      let rows = [];
      let columnHeader = [];

      if (!this.isSala) {
        columnHeader = [
          "Nº",
          "Tema",
          "Pergunta",
          "Pontos",
          "Resposta",
          "Evidência",
        ];
      } else {
        columnHeader = [
          "Nº",
          "Pilar",
          "Pergunta",
          "Pontos",
          "Resposta",
          "Evidência",
        ];
      }

      let pdfName = `Acompanhamento - ${this.payload.municipio.nome} - ${this.payload.municipio.nome}`;

      source.forEach((element) => {
        var temp = [];
        if (element.resposta === true) {
          element.resposta = "SIM";
        }
        if (element.resposta === false) {
          element.resposta = "NÃO";
        }
        temp = [
          element.pergunta.numero,
          element.pergunta.tema.nome,
          element.pergunta.texto,
          element.pergunta.pontos,
          element.resposta,
          element.pergunta.evidencia,
        ];
        rows.push(temp);
      });
      var subTitulo = this.payload.nome;
      var dimensions = {
        width: 0,
        height: 50,
      };
      var titulo = "Acompanhamento Cidade Empreendedora";
      var logoCidade = new Image();
      if (this.isTur) {
        titulo = "Acompanhamento";
      }
      if (this.isSala) {
        subTitulo =
          subTitulo == "Diagnóstico" ? "Acompanhamento Geral" : subTitulo;
        titulo = "Selo Sebrae de Referência em Atendimento";
        logoCidade.src = await convertImgToBase64(
          `https://slide1-images.s3.amazonaws.com/public/logo/logo-selo.png`,
          400,
          500
        );

        dimensions = {
          width: 70,
          height: 70,
        };
      } else {
        logoCidade.src = await convertImgToBase64(this.logos.logo);
      }

      var logoSebrae = new Image();
      logoSebrae.src = await convertImgToBase64(
        "https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
      );

      var doc = new JsPDF("l", "pt");
      doc.setFontSize(16).setFont(undefined, "bold");
      doc.text(250, 45, titulo);

      doc.setFontSize(14).setFont(undefined, "normal");
      doc.text(250, 65, subTitulo);

      doc.setFontSize(13).setFont(undefined, "bold");
      doc.text(250, 85, this.payload.municipio.nome);
      doc.addImage(logoSebrae, "PNG", 700, 30, 100, 50);
      if (
        this.isFullAdmin ||
        (this.groupsConfig.visualizarLogo && this.config.visualizarLogo)
      ) {
        doc.addImage(
          logoCidade,
          "PNG",
          40,
          30,
          dimensions.width,
          dimensions.height
        );
        8;
      }
      doc.setFontSize(11).setFont(undefined, "normal");
      doc.autoTable(columnHeader, rows, {
        startY: 120,
        styles: { overflow: "linebreak", cellWidth: "wrap" },
        columnStyles: {
          text: {
            cellWidth: "auto",
          },
          1: {
            cellWidth: "auto",
          },
          2: {
            cellWidth: "auto",
          },
          3: {
            cellWidth: "auto",
          },
          4: {
            cellWidth: "auto",
          },
          5: {
            cellWidth: "auto",
          },
          6: {
            cellWidth: "auto",
          },
        },
      });
      doc.save(pdfName + ".pdf");
    },
    async getPergunta() {
      try {
        const response = await cityQuestionAPI.getPerguntaByPerguntaId(
          this.municipioId,
          1003,
          this.uf,
          this.isParceiro,
          "prod"
        );

        this.pergunta1005Bloqueada = !(
          response &&
          response.data &&
          response.data.resposta
        );

        this.atualizarBloqueioPergunta1005();
        this.setLoading(false);

        return response.data;
      } catch (error) {
        console.error("Erro ao obter a pergunta:", error);
        this.setLoading(false);

        return null;
      }
    },
    regrasExibicaoPergunta(item) {
      if (!item || !item.pergunta || !item.pergunta.numero) {
        return false;
      }

      const numero = item.pergunta.numero;

      const regra = this.regrasCondicionais.find(
        (r) => r.perguntaCondicional == numero
      );

      if (regra) {
        if (!this.payload || !this.payload.perguntas) {
          return false;
        }

        const perguntaPrincipal = this.payload.perguntas.find(
          (p) => p && p.pergunta && p.pergunta.numero == regra.perguntaPrincipal
        );

        if (!perguntaPrincipal) {
          return true;
        }

        return perguntaPrincipal.resposta;
      }
      return true;
    },
  },
  mounted() {
    this.getAcompanhamento();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorEspecialistaMunicipio",
      "isConsultorCondutorMunicipio",
      "isFullAdmin",
      "isSala",
      "isTur",
      "logos",
    ]),

    availableQuestions() {
      if (
        !this.payload ||
        !this.payload.perguntas ||
        this.payload.perguntas.length === 0
      ) {
        return [];
      }

      return this.payload.perguntas
        .filter(
          (item) => item && item.pergunta && this.regrasExibicaoPergunta(item)
        )
        .map((item) => ({
          numero: item.pergunta.numero || "",
          texto: item.pergunta.texto || "",
          tema: item.pergunta.tema ? item.pergunta.tema.nome : "",
          display: `${item.pergunta.numero || ""} - ${(
            item.pergunta.texto || ""
          ).substring(0, 50)}${
            (item.pergunta.texto || "").length > 50 ? "..." : ""
          }`,
        }))
        .sort((a, b) => {
          // Ordenar por número da pergunta
          const numA = parseFloat(a.numero) || 0;
          const numB = parseFloat(b.numero) || 0;
          return numA - numB;
        });
    },

    totalCount() {
      if (!this.payload || !this.payload.perguntas) {
        return 0;
      }
      return this.payload.perguntas.filter(
        (item) => item && item.pergunta && this.regrasExibicaoPergunta(item)
      ).length;
    },

    filteredCount() {
      if (!this.payload || !this.payload.perguntas) {
        return 0;
      }

      let filtered = this.payload.perguntas.filter(
        (item) => item && item.pergunta && this.regrasExibicaoPergunta(item)
      );

      // Aplicar filtro por perguntas selecionadas
      if (this.search.length > 0) {
        filtered = filtered.filter(
          (item) =>
            item && item.pergunta && this.search.includes(item.pergunta.numero)
        );
      }

      // Aplicar filtro por texto
      if (this.textSearch) {
        const searchLower = this.textSearch.toLowerCase();
        filtered = filtered.filter(
          (item) =>
            item &&
            item.pergunta &&
            (item.pergunta.texto.toLowerCase().includes(searchLower) ||
              item.pergunta.numero.toLowerCase().includes(searchLower) ||
              (item.pergunta.tema &&
                item.pergunta.tema.nome.toLowerCase().includes(searchLower)))
        );
      }

      return filtered.length;
    },

    filteredItems() {
      if (
        !this.payload ||
        !this.payload.perguntas ||
        this.payload.perguntas.length === 0
      ) {
        return [];
      }

      let groupBy = this.payload.perguntas
        .filter(
          (item) => item && item.pergunta && this.regrasExibicaoPergunta(item)
        )
        .map((item) => {
          return {
            ...item,
            temaNome: item.pergunta.tema ? item.pergunta.tema.nome : "",
          };
        });

      // Aplicar filtro por perguntas selecionadas
      if (this.search.length > 0) {
        groupBy = groupBy.filter(
          (item) =>
            item && item.pergunta && this.search.includes(item.pergunta.numero)
        );
      }

      // Aplicar filtro por texto
      if (this.textSearch) {
        const searchLower = this.textSearch.toLowerCase();
        groupBy = groupBy.filter(
          (item) =>
            item &&
            item.pergunta &&
            (item.pergunta.texto.toLowerCase().includes(searchLower) ||
              item.pergunta.numero.toLowerCase().includes(searchLower) ||
              (item.pergunta.tema &&
                item.pergunta.tema.nome.toLowerCase().includes(searchLower)))
        );
      }

      let key = "temaNome";
      let aux = groupBy.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});

      groupBy = Object.keys(aux).map((key) => {
        return {
          name: key,
          children: aux[key].sort((a, b) => {
            const numA = parseFloat(a.pergunta.numero) || 0;
            const numB = parseFloat(b.pergunta.numero) || 0;
            return numA - numB;
          }),
        };
      });

      return groupBy.sort(function (a, b) {
        return a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.category-header {
  background: linear-gradient(
    135deg,
    var(--corPrimaria, #1976d2) 0%,
    var(--corPrimaria, #1976d2) 100%
  );
  position: sticky;
  top: 0;
  z-index: 3;
  border-bottom: 3px solid rgba(255, 255, 255, 0.2);
}

.question-container {
  transition: all 0.2s ease;
  min-height: 40px;

  &:hover {
    border-left-color: var(--corPrimaria, #1976d2);
    background-color: rgba(25, 118, 210, 0.02);
  }

  // Garantir que o header da pergunta tenha espaço suficiente
  .d-flex.align-center {
    flex-wrap: nowrap;
    gap: 8px;

    .v-chip {
      flex-shrink: 0;
    }
  }
}
.question-text {
  font-size: 0.95rem;
  line-height: 1.4;
  font-weight: 500;
}

.question-info {
  .evidence-info {
    background-color: #f5f5f5;
    padding: 6px 8px;
    border-radius: 4px;
    border-left: 3px solid #2196f3;
  }
}

// Card de evidência com estilo melhorado
.evidence-card {
  border-left: 4px solid #1976d2 !important;
  background: linear-gradient(
    135deg,
    #e3f2fd 0%,
    #bbdefb 50%,
    #e1f5fe 100%
  ) !important;
  transition: all 0.3s ease !important;
  border-radius: 8px !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(25, 118, 210, 0.25) !important;
    background: linear-gradient(
      135deg,
      #bbdefb 0%,
      #90caf9 50%,
      #81d4fa 100%
    ) !important;
  }

  .v-card-text {
    padding: 12px 16px !important;
  }

  .text-caption {
    letter-spacing: 0.5px;
    color: #1565c0 !important;
    font-weight: 600 !important;
  }
}

.line-height-comfortable {
  line-height: 1.5 !important;
}

.question-inputs {
  .comment-input {
    :deep(.v-input__append-inner) {
      margin-top: 4px;
    }
  }
}

.readonly-comment {
  border-left: 3px solid #9e9e9e;
}

.disabled-avatar {
  pointer-events: none;
  opacity: 0.5;
  filter: grayscale(100%);
}

// Tabela mais compacta
:deep(.compact-table) {
  tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    height: auto !important;
    min-height: 48px !important;

    // Linhas pares com cor de fundo alternada
    &:nth-child(even) {
      background-color: #dfeaf5 !important;
    }
  }

  .v-data-table__td {
    padding: 8px 12px !important;
    vertical-align: top !important;
  }

  .v-data-table-header__content {
    font-weight: 600;
    color: var(--corPrimaria, #1976d2);
    padding: 12px !important;
  }
}

// Linha compacta
:deep(.compact-row) {
  .v-data-table__td {
    padding: 6px 10px !important;
  }
}

// Botões de thumb com cores explícitas
.thumb-btn {
  width: 80px !important;
  height: 80px !important;
  border-radius: 50% !important;
  transition: all 0.3s ease !important;
  border: 2px solid #e0e0e0 !important;

  &:hover {
    transform: scale(1.1);
  }

  // Estado não selecionado (cinza)
  &--unselected {
    background-color: #f5f5f5 !important;
    border-color: #bdbdbd !important;

    .v-icon {
      color: #616161 !important;
    }

    &:hover {
      background-color: #eeeeee !important;
      border-color: #9e9e9e !important;
    }
  }

  // Estado selecionado
  &--selected {
    border: none !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

    .v-icon {
      color: white !important;
    }
  }

  // SIM selecionado (verde)
  &--success {
    background-color: #4caf50 !important;

    &:hover {
      background-color: #43a047 !important;
      box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3) !important;
    }
  }

  // NÃO selecionado (vermelho)
  &--error {
    background-color: #f44336 !important;

    &:hover {
      background-color: #e53935 !important;
      box-shadow: 0 6px 16px rgba(244, 67, 54, 0.3) !important;
    }
  }

  // Estado desabilitado
  &.v-btn--disabled {
    opacity: 0.4 !important;
    transform: none !important;
    box-shadow: none !important;
  }
}

// Indicador de resposta
.response-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
} // Input numérico centralizado

.numeric-field-centered {
  width: 100%;
}
:deep(.numeric-field-centered input[type="number"]) {
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
}

:deep(.numeric-field-centered .v-field-label) {
  font-size: 0.75rem;
  font-weight: 500;
} // Melhor responsividade
@media (max-width: 960px) {
  .v-container {
    padding: 8px;
  }

  .category-header {
    position: relative;
  }

  .question-container {
    padding: 12px !important;
  }
}

// Transições suaves
.v-card {
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
  }
}

// Estilos para o card de filtros
.filter-card {
  border: 1px solid #e3f2fd;

  .filter-header {
    background: linear-gradient(135deg, #f8fbff 0%, #e3f2fd 100%);
    border-bottom: 1px solid #e1e5e9;
  }

  .filter-info {
    background-color: #f5f7fa;
    padding: 12px;
    border-radius: 8px;
    border-left: 4px solid var(--corPrimaria, #1976d2);
  }
}

// Melhor espaçamento para chips
.v-chip {
  margin: 2px;

  // Garantir que números não sejam cortados
  &.flex-shrink-0 {
    flex-shrink: 0 !important;
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: clip !important;

    :deep(.v-chip__content) {
      white-space: nowrap !important;
      overflow: visible !important;
      font-weight: 600;
      font-size: 0.875rem;
    }
  }
}

// Estilo para estados de loading/empty
.empty-state {
  text-align: center;
  padding: 48px 24px;

  .v-icon {
    opacity: 0.5;
  }
}
</style>
